import React, { useEffect, useState, useRef } from "react"
import { colorsByType, typesInTabs,getTypeByType } from "./sc-analyzer-frontend-data"
import { gotoResource, scrollIntoView } from "./gotoAST"
/**
 * @param props {{
 *  scState:scState
 * }}
 */
export default function RightSideShowSol({ scState }) {
  var sol=scState.solFiles.find(x=>x.path==scState.selectedFile)?.content || ''
  var lines = sol.split('\n')
  
  for(var lineIndex=1;lineIndex<lines.length;lineIndex++) {
    var curLine=lines[lineIndex]
    var befLine=lines[lineIndex-1]
    befLine=befLine.replace(/<div.*<\/div>/g,'')
    var match=befLine.match(/<div.*?>/g)
    if(match) {
      lines[lineIndex]=match[0] + curLine
    }
  }

  var ref=useRef(null)

  function clickItem(evt){
    var item=evt.target
    var gotoTab=item.getAttribute('goto_tab')
    // var gotoItem=item.getAttribute('name')
    var gotoFile=item.getAttribute('goto_file')
    var gotoAstId=item.getAttribute('ast_id')
    var gotoLine=item.getAttribute('goto_line')
    if(gotoFile) {
      scState.set_selectedFile(gotoFile)
    }
    if(gotoLine) {
      setTimeout(()=>{
        var elm=document.querySelector(`[data-line="${gotoLine}"]`)
        //@ts-ignore
        elm.style.border='1px solid yellow'
        setTimeout(()=>{
          //@ts-ignore
          elm.style.border=''
        },3000)
        scrollIntoView(elm)
      })
    }
    if(gotoTab) {
      gotoResource(scState, gotoTab,gotoAstId)
    }
    // var t=getTypeByType(resource.type)
    // console.log({type,name,t})
    
  }
  useEffect(()=>{
    document.body.addEventListener('click',clickItem)
    
    return ()=>document.body.removeEventListener('click',clickItem)
  },[])

  return <div  ref={ref}
  css={`
  .code {
    margin-bottom:3px;
    div {
      display:inline-block;
    }
    white-space:preserve;  
  }
  [goto_tab] {
    cursor:pointer;
  }  
  [goto_tab]=undefined {
    cursor:text;
  }  
  [comment=true] {
    color:green
  }
  font-family:monospace;
  font-size:15px;
  background-color:#222336;
  color:white;
  `}>
      {lines.map((line, index) => <div 
      data-line={index+1}
      key={index+1} css={`display:flex;`}>
        <div css="width:30px;
        min-width:40px;
        text-align:right;
        margin-right:15px;
        user-select:none;
        "         
        >
          {index+1}
        </div>
        <div className="code" dangerouslySetInnerHTML={{__html:line}} />
      </div>
      )}
  </div>
}